// 画面レイアウト
import header from '@/components/organisms/TheHeader'
import footer from '@/components/organisms/TheFooter'
import sidebar from '@/components/organisms/TheSidebar'

// ------------------------------------------------------------
// 一般画面
// ------------------------------------------------------------
import Login from '@/components/pages/login/Login'
import Top from '@/components/pages/top/Index'

// 名刺BOX
import Box from '@/components/pages/box/Index'
import Favorited from '@/components/pages/box/FilterFavorited'
import Accessed from '@/components/pages/box/FilterAccessed'
import Card from '@/components/pages/box/Card'
import CardTabOverall from '@/components/pages/box/CardTabOverall'
import CardTabExchanger from '@/components/pages/box/CardTabExchanger'
import CardTabExchangerList from '@/components/pages/box/CardTabExchangerList'
import CardTabExchangeList from '@/components/pages/box/CardTabExchangerExchanges'
import CardTabHistory from '@/components/pages/box/CardTabHistory'
import CardTabHistoryList from '@/components/pages/box/CardTabHistoryList'
import CardTabHistoryDetail from '@/components/pages/box/CardTabHistoryDetail'
import CardTabConcurrent from '@/components/pages/box/CardTabConcurrent'

// 一般画面：名刺登録
import NewCard from '@/components/pages/box/NewCard'
import NewCardEdit from '@/components/pages/box/NewCardEdit'
import NewCardDone from '@/components/pages/box/NewCardDone'
import AddcardCsv from '@/components/pages/bcardcsv/Index'

// お知らせ一覧
import Information from '@/components/pages/information/Index'
import InformationList from '@/components/pages/information/List'
import InformationDetail from '@/components/pages/information/Detail'

// ------------------------------------------------------------
// 一般画面
// ------------------------------------------------------------
export default [
  // ログイン画面
  {
    path: '/login',
    name: 'login',
    meta: {
      needAuth: false
    },
    components: {
      header,
      sidebar: null,
      footer,
      content: Login
    }
  },
  // top（ピンの振り分け）
  {
    path: '/',
    name: 'top',
    components: {
      header,
      sidebar: null,
      footer,
      content: Top
    }
  },
  // 自分の名刺
  {
    path: '/box',
    name: 'box',
    components: {
      header,
      sidebar,
      footer,
      content: Box
    }
  },
  // すべての名刺
  {
    path: '/all',
    name: 'box-all',
    components: {
      header,
      sidebar,
      footer,
      content: Box
    }
  },
  // お気に入り
  {
    path: '/favorited-bcards',
    name: 'favorite',
    components: {
      header,
      sidebar,
      footer,
      content: Favorited
    }
  },
  // 最近見た名刺
  {
    path: '/accessed-bcards',
    name: 'browsing',
    components: {
      header,
      sidebar,
      footer,
      content: Accessed
    }
  },
  // 名刺詳細
  {
    path: '/persons/:sidPerson',
    components: {
      header,
      sidebar,
      footer,
      content: Card
    },
    children: [
      {
        path: '',
        name: 'box-detail',
        component: CardTabOverall,
        props: true
      },
      {
        path: 'exchangers',
        component: CardTabExchanger,
        props: true,
        children: [
          {
            path: '',
            name: 'box-exchangers',
            component: CardTabExchangerList,
            props: true
          },
          {
            path: ':sidUser/exchanges',
            name: 'box-exchanger-exchanges',
            component: CardTabExchangeList,
            props: true
          }
        ]
      },
      {
        path: 'histories',
        component: CardTabHistory,
        props: true,
        children: [
          {
            path: '',
            name: 'box-history',
            component: CardTabHistoryList,
            props: true
          },
          {
            path: ':sidBcard',
            name: 'box-history-detail',
            component: CardTabHistoryDetail,
            props: true
          }
        ]
      },
      {
        path: 'concposts',
        name: 'box-concposts',
        component: CardTabConcurrent,
        props: true
      }
    ]
  },
  // 直接入力
  {
    path: '/add-card',
    components: {
      header,
      sidebar,
      footer,
      content: NewCard
    },
    children: [
      {
        path: '',
        name: 'addcard-manual',
        component: NewCardEdit
      },
      {
        path: ':sidPerson/done',
        name: 'addcard-manual-done',
        component: NewCardDone,
        props: true
      },
      // 「この人物に追加」ボタンの遷移先
      {
        path: ':sidPerson',
        name: 'addcard-manual-copy',
        component: NewCardEdit,
        props: true
      },
      {
        path: ':sidPerson/done',
        name: 'addcard-manual-copy-done',
        component: NewCardDone,
        props: true
      }
    ]
  },
  // 人物詳細から直接入力
  {
    path: '/persons/:sidPerson/add-card',
    components: {
      header,
      sidebar,
      footer,
      content: NewCard
    },
    children: [
      {
        path: '',
        name: 'addcard-manual-clone',
        component: NewCardEdit,
        props: true
      },
      {
        path: 'done',
        name: 'addcard-manual-clone-done',
        component: NewCardDone,
        props: true
      }
    ]
  },
  // 画像から登録
  {
    path: '/add-image',
    components: {
      header,
      sidebar,
      footer,
      content: NewCard
    },
    children: [
      {
        path: '',
        name: 'addcard-image',
        component: NewCardEdit
      },
      {
        path: ':sidPerson/done',
        name: 'addcard-image-done',
        component: NewCardDone,
        props: true
      }
    ]
  },
  // 人物詳細から画像から登録
  {
    path: '/persons/:sidPerson/add-image',
    components: {
      header,
      sidebar,
      footer,
      content: NewCard
    },
    children: [
      {
        path: '',
        name: 'addcard-image-clone',
        component: NewCardEdit,
        props: true
      },
      {
        path: 'done',
        name: 'addcard-image-clone-done',
        component: NewCardDone,
        props: true
      }
    ]
  },
  // CSVから一括登録
  {
    path: '/add-csv',
    name: 'addcard-csv',
    meta: {
      isAdminPage: false,
      isReloadGuardPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: AddcardCsv
    }
  },
  // お知らせ一覧
  {
    path: '/information',
    meta: {
      isAdminPage: false
    },
    components: {
      header,
      sidebar,
      footer,
      content: Information
    },
    children: [
      // 一覧画面
      {
        path: '',
        name: 'information',
        component: InformationList
      },
      // 詳細画面
      {
        path: ':id',
        name: 'information-detail',
        component: InformationDetail,
        props: true // $route.params.idをpropsに引き渡す
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.general.js